import { Box, Skeleton, SkeletonProps } from '@mui/material';

interface FormFieldSkeletonProps {
  FieldSkeletonProps?: SkeletonProps;
  fieldType?: 'input' | 'textarea' | 'file' | 'location';
}
export const FormFieldSkeleton: React.FC<FormFieldSkeletonProps> = ({ FieldSkeletonProps, fieldType = 'input' }) => {
  const getFieldHeight = (): string => {
    switch (fieldType) {
      case 'location':
        return '15rem';
      case 'textarea':
        return '7.75rem';
      default:
        return '3rem';
    }
  };
  return (
    <Box>
      <Skeleton width="10rem" />
      {fieldType === 'location' && <Skeleton variant="rectangular" height="3rem" width="100%" sx={{ mb: 0.5 }} />}
      <Skeleton
        variant="rectangular"
        height={getFieldHeight()}
        width={fieldType === 'file' ? '12.5rem' : '100%'}
        {...FieldSkeletonProps}
      />
    </Box>
  );
};
